// Central company configuration. Static brand data lives here so future
// CMS integration can replace these values without touching components.

export const COMPANY = {
  name: "TESSA",
  fullName: "TESSA Corporation",
  origin: "Ecuador",
  instagram: "@tessacorporation",
  instagramUrl: "https://www.instagram.com/tessacorporation/",
  tagline: "Premium Ecuadorian Flowers",
  // Optional social profiles — a footer icon renders only when its URL is set.
  linkedinUrl: "",
  facebookUrl: "",
};

export const BRAND_COLORS = {
  ivory: "#F6F2EC",
  green: "#183C32",
  deepGreen: "#102C25",
  burgundy: "#D92A47",
  softRose: "#D9A9AE",
  charcoal: "#252525",
  warmGray: "#817B74",
  champagne: "#C4A46B",
  white: "#FFFFFF",
};
